export const checkinMisc = {
  authorityBadges: {
    states: {
      ok: "Inviato con successo",
      error: "Errore di invio",
      notConfigured: "Non configurato",
      pending: "Invio in sospeso",
    },
    errorNoInfo: "Errore (nessun dettaglio)",
  },
  msgPolice: {
    title: "Informazioni",
    pendingSyncText:
      "I dati del check-in sono in attesa di sincronizzazione; verranno inviati alle autorità locali lo stesso giorno in cui l'ospite arriva presso l'alloggio.",
    entryDateLabel: "Data di arrivo:",
    syncedText:
      "I dati dell'ospite {name} sono stati sincronizzati con successo con le autorità locali.",
    syncDateLabel: "Data di sincronizzazione:",
    errorText:
      "Per motivi esterni, non è stato possibile completare la sincronizzazione con le autorità locali.",
    close: "Chiudi",
  },
};
